import { PropTypes } from "prop-types"

import Input from "../Input"

export const InputTelephone = props => {
  return <Input className="oj-input-telephone" type="tel" {...props} />
}

InputTelephone.propTypes = {
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  placeholder: PropTypes.string
}

export default InputTelephone
